import styled, { createGlobalStyle, keyframes } from 'styled-components';
import { breakpoints } from 'config/config';
import { BUTTON_STATES } from 'styles/buttonStates';

export const FarmGlobalStyle = createGlobalStyle`
  @media (max-width: ${breakpoints.xs}px) {
    .mobile-header-container .buy-latvia-food {
      display: none !important;
    }
  }

  .farm-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 10px 5px 8px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
    line-height: normal;
    white-space: nowrap;

    &.farm-status-open {
      background-color: ${({ theme }) => theme.statusOpenBg};
      color: ${({ theme }) => theme.statusOpenText};
    }

    &.farm-status-closing {
      background-color: ${({ theme }) => theme.statusClosingBg};
      color: ${({ theme }) => theme.statusClosingText};
    }

    &.farm-status-closed {
      background-color: ${({ theme }) => theme.statusClosedBg};
      color: ${({ theme }) => theme.topPriceBgColor};
    }
  }

  .farm-status-dot > div {
    display: flex;
    width: 8px;
    height: 8px;
  }

  .farm-place-modal {
    .ant-modal-content {
      padding: 0;
      border-radius: 5px;
      overflow: hidden;
      box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
    }

    .farm-modal {
      position: relative;
      display: flex;
      flex-direction: column;
      font-family: ${({ theme }) => theme.fontText};
      color: ${({ theme }) => theme.black};
    }

    .farm-modal-handle {
      display: none;
    }

    .farm-modal-media {
      position: relative;
      height: 341px;
      overflow: hidden;
    }

    .farm-modal-map,
    .farm-modal-map > * {
      width: 100%;
      height: 100%;
    }

    .farm-modal-tag {
      position: absolute;
      left: 24px;
      bottom: 27px;
      z-index: 1;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 6px 12px 6px 10px;
      border-radius: 999px;
      background-color: ${({ theme }) => theme.white};
      font-size: 13px;
      font-weight: 700;
      line-height: normal;
    }

    .farm-modal-tag-icon > div {
      display: flex;
      width: 16px;
      height: 16px;
    }

    .farm-modal-close.ant-btn {
      position: absolute;
      top: 16px;
      right: 16px;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      padding: 0;
      border: none;
      border-radius: 999px;

      &,
      &${BUTTON_STATES} {
        background-color: ${({ theme }) => theme.brand02};
      }

      .ant-btn-icon > div {
        display: flex;
        width: 18px;
        height: 18px;
      }
    }

    .farm-modal-body {
      display: flex;
      flex-direction: column;
      gap: 22px;
      padding: 28px 32px 32px;
    }

    .farm-modal.no-media .farm-modal-body {
      padding-top: 72px;
    }

    .farm-modal-heading {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .farm-modal-heading-text {
      display: flex;
      flex: 1;
      flex-direction: column;
      gap: 4px;
      min-width: 0;
    }

    .farm-modal-title {
      margin: 0;
      font-size: 28px;
      font-weight: 800;
      line-height: normal;
      color: ${({ theme }) => theme.black};
    }

    .farm-modal-subtitle {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.farmSectionMuted};
    }

    .farm-modal-heading .farm-status {
      padding: 7px 14px 7px 10px;
      font-size: 14px;
      font-weight: 700;

      .farm-status-dot > div {
        width: 9px;
        height: 9px;
      }
    }

    .farm-modal-columns {
      display: flex;
      align-items: flex-start;
      gap: 28px;
    }

    .farm-modal-info {
      display: flex;
      flex: none;
      flex-direction: column;
      gap: 18px;
      width: 340px;
    }

    .farm-modal-info-row {
      display: flex;
      align-items: flex-start;
      gap: 12px;
    }

    .farm-modal-info-icon {
      display: flex;
      flex: none;
      align-items: center;
      justify-content: center;
      width: 38px;
      height: 38px;
      border-radius: 10px;
      background-color: ${({ theme }) => theme.farmSectionTint};
    }

    .farm-modal-info-icon-lg > div {
      display: flex;
      width: 18px;
      height: 18px;
    }

    .farm-modal-info-icon-sm {
      display: none;

      > div {
        display: flex;
        width: 16px;
        height: 16px;
      }
    }

    .farm-modal-info-text {
      display: flex;
      flex: 1;
      flex-direction: column;
      gap: 2px;
      min-width: 0;
      font-weight: 600;
      line-height: normal;
    }

    .farm-modal-info-label {
      font-size: 12px;
      color: ${({ theme }) => theme.farmSectionMuted};
    }

    .farm-modal-info-value {
      font-size: 15px;
      color: ${({ theme }) => theme.black};
      overflow-wrap: anywhere;
    }

    a.farm-modal-info-value:hover {
      color: ${({ theme }) => theme.black};
      text-decoration: underline;
    }

    .farm-modal-copy.ant-btn {
      display: none;
      flex: none;
      width: auto;
      height: auto;
      padding: 0;
      border: none;

      &,
      &${BUTTON_STATES} {
        background: none;
      }

      .ant-btn-icon > div {
        display: flex;
        width: 16px;
        height: 16px;
      }
    }

    .farm-modal-nav {
      display: flex;
      gap: 8px;

      a {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 9px 16px 9px 12px;
        border-radius: 40px;
        background-color: ${({ theme }) => theme.brand01};
        color: ${({ theme }) => theme.white};
        font-size: 14px;
        font-weight: 600;
        line-height: normal;
        white-space: nowrap;

        &:hover {
          color: ${({ theme }) => theme.white};
          opacity: 0.9;
        }
      }
    }

    .farm-modal-nav-icon > div {
      display: flex;
      width: 14px;
      height: 14px;
    }

    .farm-modal-hours {
      display: flex;
      flex: 1;
      flex-direction: column;
      min-width: 0;
      padding: 18px 18px 14px;
      border-radius: 12px;
      background-color: ${({ theme }) => theme.grayBg};
    }

    .farm-modal-hours-head {
      display: flex;
      align-items: center;
      gap: 8px;
      padding-bottom: 10px;
      font-size: 17px;
      font-weight: 700;
      line-height: normal;

      .farm-modal-info-icon {
        width: auto;
        height: auto;
        border-radius: 0;
        background: none;
      }
    }

    .farm-modal-hours-row {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 9px 10px;
      border-radius: 8px;
      font-size: 15px;
      line-height: normal;

      &.today {
        border: 1.5px solid ${({ theme }) => theme.brand02};
        background-color: ${({ theme }) => theme.white};

        .farm-modal-hours-day,
        .farm-modal-hours-time {
          font-weight: 700;
        }
      }
    }

    .farm-modal-hours-day {
      font-weight: 500;
    }

    .farm-modal-hours-today {
      padding: 2px 8px;
      border-radius: 999px;
      background-color: ${({ theme }) => theme.brand02};
      color: ${({ theme }) => theme.white};
      font-size: 11px;
      font-weight: 700;
    }

    .farm-modal-hours-time {
      margin-left: auto;
      font-weight: 600;
      white-space: nowrap;

      &.closed {
        color: ${({ theme }) => theme.topPriceBgColor};
      }
    }

    .farm-modal-hours-note {
      margin: 0;
      font-size: 12px;
      line-height: normal;
      color: ${({ theme }) => theme.farmSectionMuted};
    }

    @media only screen and (max-width: ${breakpoints.lg}px) {
      .farm-modal-media {
        height: 21.3125rem;
      }

      .farm-modal-tag {
        left: 1.5rem;
        bottom: 1.6875rem;
        gap: 0.375rem;
        padding: 0.375rem 0.75rem 0.375rem 0.625rem;
        font-size: 0.8125rem;
      }

      .farm-modal-tag-icon > div {
        width: 1rem;
        height: 1rem;
      }

      .farm-modal-close.ant-btn {
        top: 1rem;
        right: 1rem;
        width: 2.5rem;
        height: 2.5rem;

        .ant-btn-icon > div {
          width: 1.125rem;
          height: 1.125rem;
        }
      }

      .farm-modal-body {
        gap: 1.375rem;
        padding: 1.75rem 2rem 2rem;
      }

      .farm-modal.no-media .farm-modal-body {
        padding-top: 4.5rem;
      }

      .farm-modal-heading {
        gap: 0.75rem;
      }

      .farm-modal-heading-text {
        gap: 0.25rem;
      }

      .farm-modal-title {
        font-size: 1.75rem;
      }

      .farm-modal-subtitle {
        font-size: 0.875rem;
      }

      .farm-modal-heading .farm-status {
        padding: 0.4375rem 0.875rem 0.4375rem 0.625rem;
        font-size: 0.875rem;

        .farm-status-dot > div {
          width: 0.5625rem;
          height: 0.5625rem;
        }
      }

      .farm-modal-columns {
        gap: 1.75rem;
      }

      .farm-modal-info {
        gap: 1.125rem;
        width: 21.25rem;
      }

      .farm-modal-info-row {
        gap: 0.75rem;
      }

      .farm-modal-info-icon {
        width: 2.375rem;
        height: 2.375rem;
      }

      .farm-modal-info-icon-lg > div {
        width: 1.125rem;
        height: 1.125rem;
      }

      .farm-modal-info-icon-sm {
        > div {
          width: 1rem;
          height: 1rem;
        }
      }

      .farm-modal-info-text {
        gap: 0.125rem;
      }

      .farm-modal-info-label {
        font-size: 0.75rem;
      }

      .farm-modal-info-value {
        font-size: 0.9375rem;
      }

      .farm-modal-copy.ant-btn {
        .ant-btn-icon > div {
          width: 1rem;
          height: 1rem;
        }
      }

      .farm-modal-nav {
        gap: 0.5rem;

        a {
          gap: 0.375rem;
          padding: 0.5625rem 1rem 0.5625rem 0.75rem;
          font-size: 0.875rem;
        }
      }

      .farm-modal-nav-icon > div {
        width: 0.875rem;
        height: 0.875rem;
      }

      .farm-modal-hours {
        padding: 1.125rem 1.125rem 0.875rem;
      }

      .farm-modal-hours-head {
        gap: 0.5rem;
        padding-bottom: 0.625rem;
        font-size: 1.0625rem;
      }

      .farm-modal-hours-row {
        gap: 0.5rem;
        padding: 0.5625rem 0.625rem;
        font-size: 0.9375rem;
      }

      .farm-modal-hours-today {
        padding: 0.125rem 0.5rem;
        font-size: 0.6875rem;
      }

      .farm-modal-hours-note {
        font-size: 0.75rem;
      }
    }

    @media only screen and (max-width: ${breakpoints.md}px) {
      &.ant-modal-wrap.ant-modal-centered .ant-modal {
        position: fixed;
        top: auto;
        right: 1rem;
        bottom: 1rem;
        left: 1rem;
        width: auto !important;
        max-width: none;
        margin: 0;
        padding: 0;
      }

      .ant-modal-content {
        max-height: calc(100dvh - 6rem);
        overflow-y: auto;
      }

      .farm-modal-handle {
        display: block;
        width: 2.5rem;
        height: 0.25rem;
        margin: 0.625rem auto 0.375rem;
        border-radius: 2px;
        background-color: ${({ theme }) => theme.tabDivider};
      }

      .farm-modal-media {
        height: 8.75rem;
        margin: 0.25rem 1rem 0;
        border-radius: 16px;
      }

      .farm-modal-tag {
        left: 0.75rem;
        bottom: 0.875rem;
        padding: 0.3125rem 0.625rem 0.3125rem 0.5rem;
        font-size: 0.75rem;
      }

      .farm-modal-tag-icon > div {
        width: 0.875rem;
        height: 0.875rem;
      }

      .farm-modal-close.ant-btn {
        top: 0.5rem;
        right: 0.5rem;
        width: 2.25rem;
        height: 2.25rem;

        .ant-btn-icon > div {
          width: 1rem;
          height: 1rem;
        }
      }

      .farm-modal-body {
        gap: 1.125rem;
        padding: 1.125rem 1rem 1.25rem;
      }

      .farm-modal.no-media .farm-modal-body {
        padding-top: 3.25rem;
      }

      .farm-modal-heading {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
      }

      .farm-modal-title {
        font-size: 1.5rem;
      }

      .farm-modal-subtitle {
        display: none;
      }

      .farm-modal-heading .farm-status {
        padding: 0.3125rem 0.75rem 0.3125rem 0.625rem;
        font-size: 0.8125rem;

        .farm-status-dot > div {
          width: 0.5rem;
          height: 0.5rem;
        }
      }

      .farm-modal-columns {
        flex-direction: column;
        align-items: stretch;
        gap: 1.125rem;
      }

      .farm-modal-info {
        width: auto;
      }

      .farm-modal-info-row {
        align-items: center;
      }

      .farm-modal-info-icon {
        width: 2.25rem;
        height: 2.25rem;
      }

      .farm-modal-info-icon-lg {
        display: none;
      }

      .farm-modal-info-icon-sm {
        display: flex;
      }

      .farm-modal-info-text {
        gap: 1px;
      }

      .farm-modal-copy.ant-btn {
        display: flex;
      }

      .farm-modal-nav a {
        flex: 1;
        padding: 0.6875rem 0.75rem;
      }

      .farm-modal-hours {
        padding: 0.875rem 0.75rem 0.625rem;
      }

      .farm-modal-hours-head {
        padding-bottom: 0.375rem;
        font-size: 1rem;
      }

      .farm-modal-hours-row {
        padding: 0.5rem 0.625rem;
        font-size: 0.875rem;
      }
    }
  }

  .farm-video-modal .ant-modal-content {
    padding: 0;
    overflow: hidden;
    background-color: ${({ theme }) => theme.black2};
  }

  .farm-video-modal .ant-modal-close {
    color: ${({ theme }) => theme.white};
  }

  .farm-video-frame {
    aspect-ratio: 16 / 9;

    iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: 0;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .farm-status {
      gap: 0.375rem;
      padding: 0.3125rem 0.625rem 0.3125rem 0.5rem;
      font-size: 0.8125rem;
    }

    .farm-status-dot > div {
      width: 0.5rem;
      height: 0.5rem;
    }
  }
`;

const photoStripScroll = keyframes`
  from {
    transform: translateX(calc(-50% - var(--farm-photo-strip-gap) / 2));
  }

  to {
    transform: translateX(0);
  }
`;

export const StyledFarmView = styled.div`
  font-family: ${({ theme }) => theme.fontText};
  color: ${({ theme }) => theme.black};

  p {
    margin: 0;
  }

  .farm-intro {
    background-color: ${({ theme }) => theme.whiteSmoke};
    padding: 20px 0 50px;
  }

  .farm-nav {
    margin-bottom: 32px;
  }

  .farm-hero {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 36px;
  }

  .farm-hero-main {
    display: flex;
    align-items: stretch;
    gap: 36px;
    min-width: 0;
  }

  .farm-hero-logo {
    position: relative;
    flex: none;
    width: 126px;
    height: 126px;
    border-radius: 5px;
    background-color: ${({ theme }) => theme.white};
    overflow: visible;

    > div,
    .ant-image {
      width: 100%;
      height: 100%;
    }

    .ant-image {
      border-radius: 5px;
      overflow: hidden;
    }

    .ant-image img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .farm-hero-cooperative {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 40%);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.brand02};
    background-color: ${({ theme }) => theme.white};
    overflow: hidden;

    img {
      width: 70%;
      height: 70%;
      object-fit: contain;
    }
  }

  .farm-hero-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;
    min-width: 0;
  }

  .farm-hero-title-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
  }

  .farm-hero-title {
    margin: 0;
    font-family: inherit;
    font-size: 42px;
    font-weight: 700;
    line-height: 1.15;
    color: ${({ theme }) => theme.black};
    overflow-wrap: anywhere;
  }

  .farm-hero-top {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 30px;
    background-color: ${({ theme }) => theme.topPriceBgColor};
    color: ${({ theme }) => theme.white};
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
  }

  .farm-hero-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 16px;
    line-height: 1.4;
  }

  .farm-hero-address {
    color: ${({ theme }) => theme.black2};
  }

  .farm-hero-registry {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-left: -28px;
    clip-path: inset(0 0 0 28px);

    strong {
      font-size: inherit;
      font-weight: 600;
    }
  }

  .farm-hero-registry-item {
    white-space: nowrap;
  }

  .farm-hero-registry-name {
    padding-left: 28px;
    white-space: normal;

    .farm-hero-registry-separator {
      display: none;
    }
  }

  .farm-hero-registry-separator {
    display: inline-block;
    width: 28px;
    color: ${({ theme }) => theme.black};
    text-align: center;
  }

  .farm-hero-aside {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    flex: none;
    max-width: 50%;
  }

  .farm-hero-actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .farm-hero-qmark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.white};
    overflow: hidden;

    > div,
    .ant-image {
      width: 100%;
      height: 100%;
    }

    .ant-image img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 4px;
    }
  }

  .farm-hero-products-btn.ant-btn {
    height: auto;
    padding: 10px 24px;
    border: none;
    border-radius: 40px;
    font-family: inherit;
    font-size: 16px;
    line-height: 1.4;
    transition: opacity 0.2s ease-in-out;

    .text {
      font-size: inherit;
    }

    &,
    &${BUTTON_STATES} {
      background-color: ${({ theme }) => theme.navDark};
      color: ${({ theme }) => theme.white};
    }

    &:hover {
      opacity: 0.9;
    }
  }

  .farm-hero-contacts {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    margin-top: auto;
  }

  .farm-hero-pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    max-width: 100%;
    padding: 5px 12px;
    border: 1px solid ${({ theme }) => theme.tagBorderColor};
    border-radius: 40px;
    background-color: ${({ theme }) => theme.white};
    color: ${({ theme }) => theme.black};
    font-size: 16px;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: border-color 0.2s ease-in-out;

    &:hover {
      border-color: ${({ theme }) => theme.navDark};
      color: ${({ theme }) => theme.black};
    }
  }

  .farm-hero-pill-icon {
    display: inline-flex;
    flex: none;
    width: 14px;
    height: 14px;

    img {
      display: block;
    }
  }

  .farm-hero-social {
    display: inline-flex;
    flex: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    transition: opacity 0.2s ease-in-out;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    &:hover {
      opacity: 0.85;
    }
  }

  .farm-details {
    background-color: ${({ theme }) => theme.white};
    padding: 100px 0;
  }

  .farm-details-layout {
    display: flex;
    align-items: flex-start;
    gap: 78px;
  }

  .farm-tabs {
    flex: 1;
    min-width: 0;
  }

  .farm-tabs .ant-tabs-nav {
    margin-bottom: 36px;
  }

  .farm-tabs .ant-tabs-nav::before {
    border-bottom-color: ${({ theme }) => theme.tabDivider};
  }

  .farm-tabs .ant-tabs-tab {
    padding: 0 0 12px;
    font-size: 16px;
  }

  .farm-tabs .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 36px;
  }

  .farm-tabs .ant-tabs-tab .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.black};
    font-size: inherit;
  }

  .farm-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.black};
    font-weight: 600;
  }

  .farm-tabs .ant-tabs-ink-bar {
    height: 2px;
    background-color: ${({ theme }) => theme.tabActiveBar};
  }

  .farm-description {
    display: flex;
    flex-direction: column;
    gap: 36px;
  }

  .farm-description-text {
    font-size: 16px;
    line-height: 26px;
    color: ${({ theme }) => theme.black};
    white-space: pre-wrap;
    overflow-wrap: anywhere;

    p {
      margin: 0 0 1em;
    }

    p:last-child {
      margin-bottom: 0;
    }

    a {
      color: ${({ theme }) => theme.black};
      text-decoration: underline;
    }
  }

  .farm-divider {
    margin: 0;
    height: 1px;
    border: 0;
    background-color: ${({ theme }) => theme.tabDivider};
  }

  .farm-services {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .farm-services-label {
    font-size: 14px;
    line-height: 1.4;
    text-transform: uppercase;
    color: ${({ theme }) => theme.black2};
  }

  .farm-services-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }

  .farm-service-tag {
    display: inline-flex;
    align-items: center;
    padding: 5px 12px;
    border: 1px solid ${({ theme }) => theme.tagBorderColor};
    border-radius: 40px;
    background-color: ${({ theme }) => theme.optionTagBg};
    color: ${({ theme }) => theme.black};
    font-size: 14px;
    line-height: 1.4;
    white-space: nowrap;
  }

  .farm-section {
    container: farm-section / inline-size;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .farm-section-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
  }

  .farm-section-heading {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .farm-section-title {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    line-height: normal;
    color: ${({ theme }) => theme.black};
  }

  .farm-section-count {
    padding: 3px 10px;
    border-radius: 999px;
    background-color: ${({ theme }) => theme.farmSectionTint};
    color: ${({ theme }) => theme.brand02};
    font-size: 13px;
    font-weight: 700;
    line-height: normal;
  }

  .farm-section-filters {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .farm-section-filter.ant-btn {
    height: auto;
    padding: 8px 14px;
    border-radius: 999px;
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;

    .text {
      font-size: inherit;
    }

    &,
    &${BUTTON_STATES} {
      border: 1px solid ${({ theme }) => theme.tabDivider};
      background-color: ${({ theme }) => theme.white};
      color: ${({ theme }) => theme.black};
    }

    &.active,
    &.active${BUTTON_STATES} {
      border-color: ${({ theme }) => theme.brand01};
      background-color: ${({ theme }) => theme.brand01};
      color: ${({ theme }) => theme.white};
    }
  }

  .farm-table {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 14px;
  }

  .farm-table-head {
    display: none;
  }

  .farm-table-row {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
    padding: 16px;
    border: 1px solid ${({ theme }) => theme.tabDivider};
    border-radius: 12px;
    background-color: ${({ theme }) => theme.white};

    &.selected {
      border-color: ${({ theme }) => theme.brand02};
    }
  }

  .farm-row-top {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .farm-col-place {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }

  .farm-section-icon {
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 999px;
    background-color: ${({ theme }) => theme.farmSectionTint};

    > div {
      display: flex;
      width: 20px;
      height: 20px;
    }
  }

  .farm-row-title {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    min-width: 0;
  }

  .farm-row-name {
    font-size: 16px;
    font-weight: 700;
    line-height: normal;
    color: ${({ theme }) => theme.black};
    overflow-wrap: anywhere;
  }

  .farm-row-tag {
    padding: 2px 8px;
    border: 1px solid ${({ theme }) => theme.tabDivider};
    border-radius: 4px;
    background-color: ${({ theme }) => theme.grayBg};
    color: ${({ theme }) => theme.farmSectionMuted};
    font-size: 12px;
    font-weight: 600;
    line-height: normal;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .farm-col-status:empty,
  .farm-col-address:empty {
    display: none;
  }

  .farm-col-address {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    line-height: normal;
    color: ${({ theme }) => theme.black};
  }

  .farm-row-icon {
    display: inline-flex;
    flex: none;

    > div {
      display: flex;
      width: 16px;
      height: 16px;
    }
  }

  .farm-row-footer {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-top: 12px;
    border-top: 1px solid ${({ theme }) => theme.tabDivider};
  }

  .farm-col-distance,
  .farm-col-where {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    gap: 8px;
    min-width: 0;
    color: ${({ theme }) => theme.farmSectionMuted};
    font-size: 13px;
    font-weight: 600;
    line-height: normal;
  }

  .farm-col-distance.empty > * {
    display: none;
  }

  .farm-row-distance,
  .farm-row-duration {
    font-size: inherit;
  }

  .farm-row-duration::before {
    content: ' · ';
    white-space: pre;
  }

  .farm-row-where {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .farm-row-where-main.has-sub {
    display: none;
  }

  .farm-col-price {
    display: flex;
    flex: none;
    flex-direction: column;
    align-items: flex-end;
  }

  .farm-row-price {
    font-size: 17px;
    font-weight: 800;
    line-height: normal;
    color: ${({ theme }) => theme.black};
    white-space: nowrap;

    &.free {
      color: ${({ theme }) => theme.statusOpenText};
    }
  }

  .farm-col-action {
    display: flex;
    flex: none;
    justify-content: flex-end;
  }

  .farm-view-btn.ant-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: auto;
    padding: 9px 12px 9px 16px;
    border-radius: 40px;
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    white-space: nowrap;

    .text {
      font-size: inherit;
    }

    &,
    &${BUTTON_STATES} {
      border: 1px solid ${({ theme }) => theme.tabDivider};
      background-color: ${({ theme }) => theme.white};
      color: ${({ theme }) => theme.black};
    }

    &.active,
    &.active${BUTTON_STATES} {
      border-color: ${({ theme }) => theme.brand01};
      background-color: ${({ theme }) => theme.brand01};
      color: ${({ theme }) => theme.white};
    }
  }

  .farm-view-btn-icon > div {
    display: flex;
    width: 16px;
    height: 16px;
  }

  .farm-table-empty {
    padding: 16px 20px;
    color: ${({ theme }) => theme.farmSectionMuted};
    font-size: 14px;
  }

  .farm-section-note {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.farmSectionMuted};
    font-size: 13px;
    line-height: normal;
  }

  .farm-section-note-icon {
    display: inline-flex;
    flex: none;

    > div {
      display: flex;
      width: 16px;
      height: 16px;
    }
  }

  .farm-section-note-link.ant-btn {
    height: auto;
    padding: 0;
    border: none;
    font: inherit;
    font-weight: 600;
    text-decoration: underline;

    .text {
      font-size: inherit;
    }

    &,
    &${BUTTON_STATES} {
      background: none;
      color: ${({ theme }) => theme.black};
    }
  }

  @container farm-section (min-width: 900px) {
    .farm-table {
      display: flex;
      flex-direction: column;
      gap: 0;
      border: 1px solid ${({ theme }) => theme.tabDivider};
      border-radius: 5px;
      overflow: hidden;
      background-color: ${({ theme }) => theme.white};
    }

    .farm-table-head {
      display: flex;
      align-items: center;
      padding: 12px 20px;
      background-color: ${({ theme }) => theme.grayBg};
      text-transform: uppercase;
    }

    .farm-table .farm-table-head > span {
      color: ${({ theme }) => theme.farmSectionMuted};
      font-size: 12px;
      font-weight: 700;
      line-height: normal;
    }

    .farm-table-row {
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      gap: 0;
      padding: 16px 20px;
      border: none;
      border-top: 1px solid ${({ theme }) => theme.tabDivider};
      border-radius: 0;

      &.selected {
        background-color: ${({ theme }) => theme.farmSectionSelected};
      }
    }

    .farm-row-top,
    .farm-row-footer {
      display: contents;
    }

    .farm-col-place {
      flex: 0 0 30%;
      gap: 10px;
      order: 1;
      padding-right: 16px;
    }

    .farm-row-icon {
      display: none;
    }

    .farm-col-status:empty,
    .farm-col-address:empty {
      display: flex;
    }

    .farm-col-distance,
    .farm-col-where {
      flex: 0 0 auto;
    }

    .farm-col-distance.empty > .farm-row-distance {
      display: inline;
    }

    .farm-row-where-main.has-sub {
      display: inline;
    }

    .farm-col-action {
      flex: 1 1 auto;
      order: 9;
    }

    .farm-places {
      .farm-col-address {
        flex-basis: 25%;
        order: 2;
        padding-right: 16px;
      }

      .farm-col-status {
        flex: 0 0 19.75%;
        order: 3;
      }

      .farm-col-distance {
        flex-basis: 11.5%;
        order: 4;
      }

      .farm-row-distance {
        display: flex;
        flex-direction: column;
        color: ${({ theme }) => theme.black};
        font-size: 15px;
        font-weight: 700;
      }

      .farm-row-duration {
        margin-top: 2px;
        color: ${({ theme }) => theme.farmSectionMuted};
        font-size: 12px;
        font-weight: 400;

        &::before {
          content: none;
        }
      }
    }

    .farm-deliveries {
      .farm-col-where {
        flex-basis: 23%;
        order: 2;
        padding-right: 16px;
        color: ${({ theme }) => theme.black};
        font-size: 14px;
        font-weight: 400;
      }

      .farm-col-price {
        flex: 0 0 12.5%;
        align-items: flex-start;
        order: 3;
      }
    }
  }

  .farm-gallery {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 16px;
  }

  .farm-gallery-item {
    position: relative;
    aspect-ratio: 1;
    border-radius: 5px;
    overflow: hidden;
    background-color: ${({ theme }) => theme.whiteSmoke};

    .ant-image,
    .ant-image img,
    .text > img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .farm-gallery-video.ant-btn {
    display: block;
    height: auto;
    padding: 0;
    border: none;
    border-radius: 5px;

    &,
    &${BUTTON_STATES} {
      background-color: ${({ theme }) => theme.whiteSmoke};
    }

    .text {
      display: contents;
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background-color: rgba(0, 0, 0, 0.3);
    }
  }

  .farm-gallery-play {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    width: 53px;
    height: 53px;
    transform: translate(-50%, -50%);
    transition: transform 0.2s ease-in-out;

    img {
      display: block;
    }
  }

  .farm-gallery-video:hover .farm-gallery-play {
    transform: translate(-50%, -50%) scale(1.08);
  }

  .farm-contact-cards {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
  }

  .farm-partner-cards {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  .farm-contact-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
    min-height: 171px;
    padding: 20px;
    border: 1px solid ${({ theme }) => theme.tabDivider};
    border-radius: 5px;
    background-color: ${({ theme }) => theme.white};
    line-height: 26px;
  }

  .farm-contact-card-head {
    min-width: 0;
  }

  .farm-contact-card-title {
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.black};
    overflow-wrap: anywhere;

    a {
      color: inherit;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .farm-contact-card-subtitle {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.cardMutedText};
    overflow-wrap: anywhere;
  }

  .farm-contact-card-body {
    display: flex;
    flex-direction: column;
    min-width: 0;

    a {
      color: ${({ theme }) => theme.black};
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .farm-photo-strip {
    --farm-photo-strip-gap: 20px;
    overflow: hidden;
    background-color: ${({ theme }) => theme.whiteSmoke};
  }

  .farm-photo-strip-track {
    display: flex;
    gap: var(--farm-photo-strip-gap);
    width: max-content;
    animation: ${photoStripScroll} var(--farm-photo-strip-duration, 60s) linear
      infinite;
  }

  .farm-photo-strip:hover .farm-photo-strip-track,
  .farm-photo-strip:focus-within .farm-photo-strip-track {
    animation-play-state: paused;
  }

  .farm-photo-strip-group {
    display: flex;
    gap: var(--farm-photo-strip-gap);
  }

  .farm-photo-strip-item {
    display: block;
    flex: none;
    width: 274px;
    height: 274px;
    border-radius: 5px;
    overflow: hidden;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .farm-photo-strip {
      overflow-x: auto;
    }

    .farm-photo-strip-track {
      animation: none;
    }

    .farm-photo-strip-group.is-clone {
      display: none;
    }
  }

  .banners {
    background-color: ${({ theme }) => theme.whiteSmoke};
    padding-bottom: 60px;

    .slick-slider {
      margin-bottom: 0;
    }

    .banner-image-wrapper {
      padding: 0;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .farm-intro {
      padding: 1.25rem 0 3.125rem;
    }

    .farm-nav {
      margin-bottom: 2rem;
    }

    .farm-hero-logo {
      width: 7.875rem;
      height: 7.875rem;
    }

    .farm-hero-cooperative {
      width: 2.625rem;
      height: 2.625rem;
    }

    .farm-hero-text {
      gap: 1rem;
    }

    .farm-hero-title-row {
      gap: 0.75rem;
    }

    .farm-hero-top {
      padding: 0.25rem 0.625rem;
      font-size: 0.75rem;
    }

    .farm-hero-details {
      gap: 0.5rem;
      font-size: 1rem;
    }

    .farm-hero-registry {
      margin-left: -1.75rem;
      clip-path: inset(0 0 0 1.75rem);
    }

    .farm-hero-registry-name {
      padding-left: 1.75rem;
    }

    .farm-hero-registry-separator {
      width: 1.75rem;
    }

    .farm-hero-aside {
      gap: 1rem;
    }

    .farm-hero-actions {
      gap: 0.5rem;
    }

    .farm-hero-qmark {
      width: 2.625rem;
      height: 2.625rem;

      .ant-image img {
        padding: 0.25rem;
      }
    }

    .farm-hero-products-btn.ant-btn {
      padding: 0.625rem 1.5rem;
      font-size: 1rem;
    }

    .farm-hero-contacts {
      gap: 0.5rem;
    }

    .farm-hero-pill {
      gap: 0.5rem;
      padding: 0.3125rem 0.75rem;
      font-size: 1rem;
    }

    .farm-hero-pill-icon {
      width: 0.875rem;
      height: 0.875rem;
    }

    .farm-hero-social {
      width: 2rem;
      height: 2rem;
    }

    .farm-tabs .ant-tabs-nav {
      margin-bottom: 2.25rem;
    }

    .farm-tabs .ant-tabs-tab {
      padding: 0 0 0.75rem;
    }

    .farm-tabs .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 2.25rem;
    }

    .farm-tabs .ant-tabs-ink-bar {
      height: 0.125rem;
    }

    .farm-description {
      gap: 2.25rem;
    }

    .farm-description-text {
      font-size: 1rem;
      line-height: 1.625rem;
    }

    .farm-services {
      gap: 0.5rem;
    }

    .farm-services-label {
      font-size: 0.875rem;
    }

    .farm-services-tags {
      gap: 0.3125rem;
    }

    .farm-service-tag {
      padding: 0.3125rem 0.75rem;
      font-size: 0.875rem;
    }

    .farm-section {
      gap: 1rem;
    }

    .farm-section-toolbar {
      gap: 0.75rem;
    }

    .farm-section-heading {
      gap: 0.5rem;
    }

    .farm-section-title {
      font-size: 1.375rem;
    }

    .farm-section-count {
      padding: 0.1875rem 0.625rem;
      font-size: 0.8125rem;
    }

    .farm-section-filters {
      gap: 0.75rem;
    }

    .farm-section-filter.ant-btn {
      padding: 0.5rem 0.875rem;
      font-size: 0.875rem;
    }

    .farm-table {
      grid-template-columns: repeat(auto-fill, minmax(18.75rem, 1fr));
      gap: 0.875rem;
    }

    .farm-table-row {
      gap: 0.75rem;
      padding: 1rem;
    }

    .farm-row-top {
      gap: 0.75rem;
    }

    .farm-col-place {
      gap: 0.75rem;
    }

    .farm-section-icon {
      width: 2.75rem;
      height: 2.75rem;

      > div {
        width: 1.25rem;
        height: 1.25rem;
      }
    }

    .farm-row-title {
      gap: 0.25rem;
    }

    .farm-row-name {
      font-size: 1rem;
    }

    .farm-row-tag {
      padding: 0.125rem 0.5rem;
      font-size: 0.75rem;
    }

    .farm-col-address {
      gap: 0.5rem;
      font-size: 0.875rem;
    }

    .farm-row-icon {
      > div {
        width: 1rem;
        height: 1rem;
      }
    }

    .farm-row-footer {
      gap: 0.5rem;
      padding-top: 0.75rem;
    }

    .farm-col-distance,
    .farm-col-where {
      gap: 0.5rem;
      font-size: 0.8125rem;
    }

    .farm-row-price {
      font-size: 1.0625rem;
    }

    .farm-view-btn.ant-btn {
      gap: 0.5rem;
      padding: 0.5625rem 0.75rem 0.5625rem 1rem;
      font-size: 0.875rem;
    }

    .farm-view-btn-icon > div {
      width: 1rem;
      height: 1rem;
    }

    .farm-table-empty {
      padding: 1rem 1.25rem;
      font-size: 0.875rem;
    }

    .farm-section-note {
      gap: 0.5rem;
      font-size: 0.8125rem;
    }

    .farm-section-note-icon {
      > div {
        width: 1rem;
        height: 1rem;
      }
    }

    .farm-gallery {
      gap: 1rem;
    }

    .farm-gallery-play {
      width: 3.3125rem;
      height: 3.3125rem;
    }

    .farm-contact-cards {
      gap: 1rem;
    }

    .farm-partner-cards {
      gap: 1rem;
    }

    .farm-contact-card {
      gap: 1.5rem;
      min-height: 10.6875rem;
      padding: 1.25rem;
      line-height: 1.625rem;
    }

    .farm-contact-card-title {
      font-size: 1rem;
    }

    .farm-contact-card-subtitle {
      font-size: 0.875rem;
    }

    .farm-contact-card-body {
      a {
        font-size: 1rem;
      }
    }

    .farm-photo-strip {
      --farm-photo-strip-gap: 1.25rem;
    }

    .banners {
      padding-bottom: 3.75rem;
    }

    .farm-hero {
      gap: 1.5rem;
    }

    .farm-hero-main {
      gap: 1.5rem;
    }

    .farm-hero-title {
      font-size: 2rem;
    }

    .farm-hero-details,
    .farm-hero-pill,
    .farm-hero-products-btn.ant-btn {
      font-size: 1rem;
    }

    .farm-details {
      padding: 3.5rem 0;
    }

    .farm-details-layout {
      gap: 2.5rem;
    }

    .farm-tabs .ant-tabs-tab {
      font-size: 1rem;
    }

    .farm-gallery {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    .farm-contact-cards {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .farm-photo-strip-item {
      width: 13.75rem;
      height: 13.75rem;
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .farm-partner-cards {
      grid-template-columns: minmax(0, 1fr);
    }

    .farm-intro {
      padding: 1rem 0 1.75rem;
    }

    .farm-nav {
      margin-bottom: 1.5rem;
    }

    .farm-hero {
      flex-direction: column;
      align-items: stretch;
      gap: 1.25rem;
    }

    .farm-hero-logo {
      width: 6rem;
      height: 6rem;
    }

    .farm-hero-title {
      font-size: 1.75rem;
    }

    .farm-hero-aside {
      align-items: flex-start;
      max-width: none;
    }

    .farm-hero-actions {
      flex-wrap: wrap;
    }

    .farm-hero-contacts {
      justify-content: flex-start;
    }

    .farm-details {
      padding: 1.75rem 0;
    }

    .farm-details-layout {
      flex-direction: column;
      gap: 1.75rem;
    }

    .farm-tabs {
      width: 100%;
    }

    .farm-tabs .ant-tabs-nav {
      margin-bottom: 1.25rem;
    }

    .farm-tabs .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 1.5rem;
    }

    .farm-description {
      width: 100%;

      td {
        width: 60%;
      }
    }

    .farm-gallery {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 0.75rem;
    }

    .farm-photo-strip {
      --farm-photo-strip-gap: 0.75rem;
    }

    .farm-photo-strip-item {
      width: 11.25rem;
      height: 11.25rem;
    }

    .banners {
      padding-bottom: 1.75rem;
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .farm-intro .container,
    .farm-details .container,
    .banners .container {
      padding-left: 1rem;
      padding-right: 1rem;
    }

    .farm-hero-main {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }

    .farm-hero-title {
      font-size: 1.5rem;
    }

    .farm-hero-registry {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.25rem;
      margin-left: 0;
      clip-path: none;
    }

    .farm-hero-registry-item {
      white-space: normal;
    }

    .farm-hero-registry-name {
      padding-left: 0;
    }

    .farm-hero-registry-separator {
      display: none;
    }

    .farm-hero-pill {
      font-size: 0.875rem;
    }

    .farm-tabs .ant-tabs-nav-list {
      gap: 0;
    }

    .farm-tabs .ant-tabs-nav-operations {
      display: none;
    }

    .farm-contact-cards {
      grid-template-columns: 1fr;
    }

    .farm-gallery {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .farm-photo-strip-item {
      width: 8.75rem;
      height: 8.75rem;
    }
  }
`;
